import axios from "axios";
import { headers } from "../global_vars";

const SETTINGS_URL = "https://ultima.icsgr.com/api/data_management/accounting_settings/";

let cachedSettings = null;
let inflight = null;

export function isAccountingManager() {
  const role = localStorage.getItem("role");
  if (role === "A" || role === "S") return true;
  return cachedSettings?.can_edit === true;
}

function syncRoleFromSettings(settings) {
  if (!settings || typeof window === "undefined") return;
  const role = settings.user_role;
  if (role) {
    try {
      localStorage.setItem("role", role);
    } catch (_e) {}
  }
}

export function clearAccountingSettingsCache() {
  cachedSettings = null;
  inflight = null;
}

export async function fetchAccountingSettings({ force = false } = {}) {
  if (!force && cachedSettings) return cachedSettings;
  if (!force && inflight) return inflight;

  const currentHeaders = {
    ...headers,
    Authorization: "Token " + localStorage.getItem("userToken"),
  };

  inflight = axios
    .get(SETTINGS_URL, { headers: currentHeaders })
    .then((res) => {
      cachedSettings = res.data || {};
      syncRoleFromSettings(cachedSettings);
      return cachedSettings;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export async function updateAccountingSettings(usdEurRate) {
  const currentHeaders = {
    ...headers,
    Authorization: "Token " + localStorage.getItem("userToken"),
  };

  const res = await axios.patch(
    SETTINGS_URL,
    { usd_eur_rate: usdEurRate },
    { headers: currentHeaders }
  );
  cachedSettings = res.data || {};
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("accounting-settings-updated", { detail: cachedSettings }));
  }
  return cachedSettings;
}
